import { Range } from '../MapWidget.types';

/**
 * Validates if the incoming value is valid for custom range feature input.
 *
 * @param {string} input - The incoming value to validate.
 * @param {number} inputIndex - The index of the input value within the value array.
 * @param {number} valueArrayLength - The total length of the value array.
 * @param {keyof Range} propName - The property name ('from' or 'to') to validate against.
 * @returns {number|undefined} - The validated value or undefined.
 *
 * @example
 * const result: Range[] = [
 *   { from: undefined, to: 0 },
 *   { from: 0, to: 0 },
 *   { from: 0, to: 0 },
 *   { from: 0, to: 0 },
 *   { from: 0, to: undefined },
 * ];
 */
export const validateIncomingValue = (
  input: string,
  inputIndex: number,
  valueArrayLength: number,
  propName: keyof Range,
): number | undefined => {
  if (input === '') {
    if ((inputIndex === 0 && propName === 'from') || (inputIndex === valueArrayLength - 1 && propName === 'to')) {
      return undefined;
    }
    return 0;
  } else {
    return Number(input);
  }
};
